export default "__VITE_ASSET__EGMHSRAs__"